import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightChartContainer, InsightChartContainerProps} from "../InsightChartContainer/InsightChartContainer";
import {PropsWithChildren} from "react";
import {BarChart, BarChartProps} from "../../chart/BarChart/BarChart";

export type InsightBarChartProps = Omit<InsightChartContainerProps, 'children'> & BarChartProps

export const InsightBarChart = (props: PropsWithChildren<InsightBarChartProps>) => {
  const {
    id,
    data,
    stacked,
    yAxisTitle,
    xAxisTitle,
    tooltipPos,
    children,
    ...rest
  } = props

  if (!data || data.titles.length === 0) {
    return (
      <InsightEmpty {...rest} >
        {children}
      </InsightEmpty>
    )
  }

  return (
    <InsightChartContainer {...rest}>
      <BarChart
        id={id}
        data={data}
        stacked={stacked}
        yAxisTitle={yAxisTitle}
        xAxisTitle={xAxisTitle}
        tooltipPos={tooltipPos}
      />
      {children}
    </InsightChartContainer>
  )
}
